import tinyColor from 'tinycolor2';

import type { TRuleWithTheme } from '@/styles/theme';

export const dropdown: TRuleWithTheme = ({ theme }) => ({
    '&.ant-dropdown .ant-dropdown-menu': {
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0,

        borderRadius: 4,
    },
    '&.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item': {
        paddingTop: '0.5rem',
        paddingRight: '0.75rem',
        paddingBottom: '0.5rem',
        paddingLeft: '0.75rem',

        borderRadius: 0,
    },

    '&.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.active': {
        color: theme.colors.brightMagenta,
        backgroundColor: tinyColor(theme.colors.lightPink).setAlpha(0.5).toRgbString(),
    },

    '&.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-active': {
        color: theme.colors.brightMagenta,
        backgroundColor: tinyColor(theme.colors.lightPink).setAlpha(0.5).toRgbString(),
    },
});
